<template>
  <scoped>
    <TextInput
      :value="displaySelection()"
      :title="title"
      :readOnly="readOnly"
      @click="display = true"
    />
    <ContentModal v-if="display">
      <Options
        v-model:selection="selection"
        :options="options"
        :readOnly="readOnly"
      />
      <Button
        v-if="readOnly"
        title="Close"
        @click="display = false"
      />
      <Button
        v-else
        title="Apply"
        @click="apply()"
      />
    </ContentModal>
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import Options from "@/components/inputs/options.vue"
  import ContentModal from "@/components/modals/content.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {ref} from "vue"

  defineProps({
    options: {
      default: null,
      required: true,
      type: Array<string>
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  })

  const emits = defineEmits(["update"])
  const selection = defineModel("selection", {
    default: null,
    required: true,
    type: Array<string>
  })
  
  const display = ref<boolean>(false)

  function apply() {
    display.value = false
    emits("update")
  }

  function displaySelection(): string {
    let output = ""
    if (!selection.value || !selection.value.length) {
      return output
    }
    for (const [index, enumeration] of selection.value.entries()) {
      if (index == 0) {
        output += enumeration
      } else {
        output += `, ${enumeration}`
      }
    }
    return output
  }
</script>
